import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-left space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6"
}
const _hoisted_3 = {
  key: 1,
  class: "border border-dashed border-slate-200 bg-white p-12 rounded-3xl text-center space-y-3"
}
const _hoisted_4 = { class: "h-12 w-12 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center mx-auto text-slate-400" }
const _hoisted_5 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6" }
const _hoisted_7 = { class: "space-y-4 min-w-0" }
const _hoisted_8 = { class: "flex items-start justify-between gap-3 min-w-0" }
const _hoisted_9 = { class: "flex items-center gap-3 min-w-0 flex-1" }
const _hoisted_10 = { class: "min-w-0 flex-1" }
const _hoisted_11 = { class: "font-black text-slate-900 truncate leading-snug text-base md:text-lg" }
const _hoisted_12 = { class: "text-xs text-slate-500 font-semibold truncate mt-0.5" }
const _hoisted_13 = { class: "rounded-2xl bg-slate-50/70 border border-slate-100 p-3 space-y-1" }
const _hoisted_14 = { class: "flex items-center justify-between text-[11px] font-bold text-slate-400 uppercase tracking-wider" }
const _hoisted_15 = {
  key: 0,
  class: "text-slate-500 lowercase font-medium"
}
const _hoisted_16 = { class: "text-xs font-bold text-slate-700 truncate" }
const _hoisted_17 = { class: "space-y-1.5" }
const _hoisted_18 = { class: "flex items-center justify-between font-bold text-xs" }
const _hoisted_19 = {
  key: 1,
  class: "text-xs font-semibold text-slate-400 lowercase"
}
const _hoisted_20 = { class: "w-full bg-slate-100 rounded-full overflow-hidden h-2.5" }
const _hoisted_21 = {
  key: 1,
  class: "h-full bg-slate-200/60 rounded-full w-full"
}
const _hoisted_22 = { class: "flex items-center justify-between border-t border-slate-100 pt-4 mt-4" }
const _hoisted_23 = { class: "text-xs text-slate-400 font-semibold" }
const _hoisted_24 = {
  key: 0,
  class: "text-slate-600 font-bold"
}
const _hoisted_25 = {
  key: 1,
  class: "text-slate-400"
}
const _hoisted_26 = {
  key: 0,
  class: "flex justify-center pt-2"
}

import { computed, ref } from "vue";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import DMSuiteIcon from "@/components/iconify/DMSuiteIcon.vue";
import { DASHBOARD_ICONS } from "@/config/dashboardIcons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesOverviewGrid',
  props: {
    services: {},
    loading: { type: Boolean }
  },
  emits: ["open-drawer"],
  setup(__props: any) {

const props = __props;



const expanded = ref(false);

const displayedServices = computed(() => {
  if (!expanded.value) {
    return props.services.slice(0, 6);
  }
  return props.services;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
            return _createVNode(_unref(Skeleton), {
              key: n,
              class: "h-56 rounded-3xl bg-slate-100 animate-pulse"
            })
          }), 64))
        ]))
      : (__props.services.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DMSuiteIcon, {
                icon: _unref(DASHBOARD_ICONS).layers,
                size: 24,
                "custom-class": "text-slate-400"
              }, null, 8, ["icon"])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "space-y-1" }, [
              _createElementVNode("p", { class: "text-base font-bold text-slate-800" }, " No services match your criteria "),
              _createElementVNode("p", { class: "text-xs text-slate-400 font-medium" }, " Try clearing search filters to see all services in your plan. ")
            ], -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedServices.value, (service) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: service.id,
                  class: "bg-white border border-slate-200/80 rounded-3xl shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 flex flex-col justify-between text-left p-6 min-h-[16rem] min-w-0"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex items-center justify-center shrink-0 h-12 w-12 rounded-2xl border shadow-2xs", service.iconWrapClass])
                        }, [
                          (typeof service.icon === 'string')
                            ? (_openBlock(), _createBlock(DMSuiteIcon, {
                                key: 0,
                                icon: service.icon,
                                size: 24,
                                "custom-class": service.iconClass
                              }, null, 8, ["icon", "custom-class"]))
                            : (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon), {
                                key: 1,
                                class: _normalizeClass(["size-6", service.iconClass])
                              }, null, 8, ["class"]))
                        ], 2),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h4", _hoisted_11, _toDisplayString(service.label), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(service.description), 1)
                        ])
                      ]),
                      _createVNode(_unref(Badge), {
                        variant: "outline",
                        class: _normalizeClass(["rounded-full font-bold px-2.5 py-0.5 text-[11px] whitespace-nowrap shrink-0 border", service.badgeClass])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(service.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Deliverable Status", -1)),
                        (service.totalTasks > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(service.completedTasks) + " of " + _toDisplayString(service.totalTasks) + " done ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(service.nextDeliverable), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-slate-400 uppercase tracking-wider" }, "Progress", -1)),
                        (service.totalTasks > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(service.valueClass)
                            }, _toDisplayString(service.progress) + "% ", 3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, " on-demand "))
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (service.totalTasks > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["h-full rounded-full transition-all duration-500", service.progressClass]),
                              style: _normalizeStyle({ width: `${service.progress}%` })
                            }, null, 6))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      (service.totalTasks > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(service.completedTasks) + "/" + _toDisplayString(service.totalTasks) + " Tasks ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, " On-Demand Service "))
                    ]),
                    _createVNode(_unref(Button), {
                      size: "sm",
                      variant: "outline",
                      class: "font-bold text-[#1f7aff] border-blue-200 bg-white hover:bg-blue-50/60 hover:text-[#185adb] h-9 px-4 text-xs rounded-xl shadow-xs transition-all",
                      onClick: ($event: any) => (_ctx.$emit('open-drawer', service))
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" View Details ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ]),
            (__props.services.length > 6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    class: "w-full sm:w-auto min-h-11 rounded-2xl border-blue-200 bg-[#f6f9ff] px-8 text-sm font-bold text-[#1f7aff] hover:bg-[#eef4ff] hover:text-[#185adb] shadow-xs flex items-center justify-center gap-2 transition-all",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(expanded.value ? 'Show Fewer Services' : `View All Services (${__props.services.length})`), 1),
                      (expanded.value)
                        ? (_openBlock(), _createBlock(DMSuiteIcon, {
                            key: 0,
                            icon: _unref(DASHBOARD_ICONS).chevronUp,
                            size: 15
                          }, null, 8, ["icon"]))
                        : (_openBlock(), _createBlock(DMSuiteIcon, {
                            key: 1,
                            icon: _unref(DASHBOARD_ICONS).chevronDown,
                            size: 15
                          }, null, 8, ["icon"]))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
  ]))
}
}

})